<template>
    <b-overlay :show="busy" rounded="sm">

        <b-card class="standardpage reports invoices border-none">
            <div class="availtable datatable">
                <b-card class="w-100pct">

                    <b-card-body class="py-0 px-0">
                        <!-- {{ selection }} -->
                        <b-tabs class="gridtabs" v-model="tabindex">
                            <b-tab>
                                <template #title>
                                    <div class="badgecontainer pr-2 mr-1">
                                        <i class="fa fa-share text-purple mr-1"></i>
                                        Publish
                                    </div>

                                </template>

                                <p class="mt-0">
                                    <b-row>
                                        <b-col>
                                            <b-alert :show="true" variant="secondary">
                                                <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                        <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                    <b-col>
                                                        <span class="h6"> Publish all transactions marked as '{{
                                                            status_from }}' to status '{{ status_to }}'
                                                            in the Invoicing system. <br>Note: Agents can only
                                                            invoice transactions that are
                                                            'ready'.
                                                        </span></b-col></b-row>
                                            </b-alert></b-col>
                                    </b-row>
                                    <b-row class="my-2">

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Invoicing By" label-for="type" label-cols="12">
                                                <treeselect instanceId="invoicing_by" type="number" v-model="source"
                                                    :clearable="false" :options="options_source"></treeselect>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12"
                                                :label="$helpers.requiredlabel(requirement, 'Supplier B/L')" :class="$helpers
                                                    .requiredlabel(requirement, 'Supplier B/L')
                                                    .slice(0, 1) == '*'
                                                    ? 'text-danger'
                                                    : ''
                                                    " label-size="sm">
                                                <treeselect placeholder="Select blac..."
                                                    searchPromptText="Type at least 3 chars..." v-model="blac"
                                                    :clearable="true" :async="true" :load-options="treeselect_loadBLAC"
                                                    :show-count="true" :flatten-search-results="true"
                                                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                                    :disabled="false">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Issue Date" label-size="sm">
                                                <b-input-group>
                                                    <daterangepicker style="width:auto !important" size="sm"
                                                        ref="issued_at" v-model="issued_at" :opens="'right'"
                                                        :locale-data="locale_data" :ranges="locale_ranges"
                                                        :showDropdowns="true" :linkedCalendars="true"
                                                        :single-date-picker="false" :disabled="false">
                                                    </daterangepicker>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="false" @click="issued_at = {
                                                                startDate: null,
                                                                endDate: null,
                                                            }
                                                                ">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>


                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Change Status" label-size="sm">
                                                <treeselect placeholder="Status" v-model="status_to" :clearable="false"
                                                    :multiple="false" :options="options_status" :matchKeys="['label']"
                                                    :disabled="false">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.label }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Include *BLOCKED* Event ?" label-for="blockedevent"
                                                label-cols="12">
                                                <b-form-radio-group id="blockedevent" v-model="blockedevent" :options="[
                                                    { text: 'Yes', value: true },
                                                    { text: 'No', value: false },
                                                ]" buttons button-variant="outline-success" size="sm"
                                                    name="radio-btn-outline"></b-form-radio-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Include *BLOCKED* SL A/C ?" label-for="blockedslac"
                                                label-cols="12">
                                                <b-form-radio-group id="blockedslac" v-model="blockedslac" :options="[
                                                    { text: 'Yes', value: true },
                                                    { text: 'No', value: false },
                                                ]" buttons button-variant="outline-success" size="sm"
                                                    name="radio-btn-outline"></b-form-radio-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>


                                    <b-row v-if="checkit_result">
                                        <b-col>
                                            <b-alert :show="true" variant="warning">
                                                <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                        <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                    <b-col>
                                                        <span class="h6">
                                                            {{ checkit_message }}
                                                        </span>
                                                    </b-col>
                                                </b-row>
                                            </b-alert>
                                        </b-col>
                                    </b-row>

                                </p>
                            </b-tab>

                            <b-tab :disabled="!blac || !checkit_result">
                                <template #title>
                                    <div class="badgecontainer pr-2 mr-1">
                                        <i class="fa fa-bullhorn text-primary mr-1"></i>
                                        Announcement
                                    </div>
                                </template>

                                <p class="mt-0">
                                <form>
                                    <b-row>
                                        <!-- <b-col cols="auto">
                                            <b-button class="ml-2" :disabled="emailed || parseFloat(item.count) == 0"
                                                squared size="sm" @click="ihold_publish(false, true)" variant="primary"
                                                style="width:80px; height:90px">
                                                <i class="fa fa-paper-plane pr-3"></i>Send
                                            </b-button>
                                        </b-col> -->
                                        <b-col cols="12">
                                            <b-row no-gutters>
                                                <b-col cols="12" class="pr-0">
                                                    <b-row align-h="between">
                                                        <b-col class="text-right" cols="1">
                                                            <b-button squared size="sm" variant="secondary"
                                                                :disabled="true">
                                                                From:
                                                            </b-button>
                                                        </b-col>
                                                        <b-col cols="11">
                                                            <b-form-group label="" label-for="from" label-cols="12"
                                                                class="text-right">
                                                                <b-input-group>
                                                                    <b-form-input type="text" v-model="item.from"
                                                                        disabled size="sm"></b-form-input>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </b-col>
                                                    </b-row>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col cols="12">
                                                    <b-row align-h="between">
                                                        <b-col class="text-right" cols="1">
                                                            <b-button squared size="sm" variant="secondary"
                                                                :disabled="true">
                                                                To:
                                                            </b-button>
                                                        </b-col>
                                                        <b-col cols="11">
                                                            <b-form-group label="" label-for="email" label-cols="12"
                                                                class="text-right">

                                                                <b-form-textarea id="to" v-model="item.to"
                                                                    placeholder="To" rows="12"
                                                                    class="smalltextarea"></b-form-textarea>
                                                                <!-- <b-input-group>
                                                            <b-form-input type="text" v-model="item.to"
                                                                placeholder="Email" size="sm"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="item.to = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>

                                                        </b-input-group> -->
                                                            </b-form-group>
                                                        </b-col>
                                                    </b-row>
                                                </b-col>
                                            </b-row>
                                            <b-row no-gutters>
                                                <b-col cols="12" class="pr-0">
                                                    <b-row align-h="between">
                                                        <b-col class="text-right" cols="1">
                                                            <b-button squared size="sm" variant="secondary"
                                                                :disabled="true">
                                                                Cc:
                                                            </b-button>
                                                        </b-col>
                                                        <b-col cols="11">
                                                            <b-form-group label="" label-for="cc" label-cols="12"
                                                                class="text-right">
                                                                <b-input-group>
                                                                    <b-form-input type="text" v-model="item.cc"
                                                                        size="sm"></b-form-input>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </b-col>
                                                    </b-row>
                                                </b-col>
                                            </b-row>
                                            <b-row class="mb-2">
                                                <b-col cols="12">
                                                    <b-row align-h="between">
                                                        <b-col class="text-right" cols="1">
                                                            <b-button squared size="sm" variant="secondary"
                                                                :disabled="true">
                                                                Title:
                                                            </b-button>
                                                        </b-col>
                                                        <b-col cols="11">
                                                            <b-form-group label="" label-for="title" label-cols="12"
                                                                class="text-right">
                                                                <b-input-group>
                                                                    <b-form-input type="text" v-model="item.subject"
                                                                        size="sm" :disabled="readonly"
                                                                        class="large strong"></b-form-input>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </b-col>
                                                    </b-row>

                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </b-row>



                                    <b-row> </b-row>

                                    <b-row>
                                        <b-col cols="12">
                                            <wysiwyg v-model="item.data" :options="{
                                                hideModules: {
                                                    code: true,
                                                },
                                            }" />
                                            <!-- hideModules: {
                        bold: true,
                        italic: true,
                        underline: true,
                        justifyLeft: true,
                        justifyCenter: true,
                        justifyRight: true,
                        headings: true,
                        link: true,
                        code: true,
                        orderedList: true,
                        unorderedList: true,
                        image: true,
                        table: true,
                        removeFormat: true,
                        separator: false,
                      }, -->
                                        </b-col>
                                    </b-row>
                                    <!-- <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Supplier BL A/C" label-for="blac" label-cols="12">
                                                <b-input-group>
                                                    <treeselect instanceId="blac" v-model="item.blac" :clearable="false"
                                                        :options="blac_options" :disabled="false"></treeselect>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row> -->

                                </form>
                                <b-row v-if="publishit_result">
                                    <b-col>
                                        <b-alert :show="true" variant="success">
                                            <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                    <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                <b-col>
                                                    <span class="h6">
                                                        {{ publishit_message }}
                                                    </span>
                                                </b-col>
                                            </b-row>
                                        </b-alert>
                                    </b-col>
                                </b-row>
                                </p>
                            </b-tab>

                        </b-tabs>

                    </b-card-body>
                    <b-card-footer class="nopadding mt-2">
                        <b-row no-gutters>
                            <b-col class="text-left" cols="auto">
                                <b-button v-if="tabindex == 0" squared size="sm" variant="warning"
                                    @click="ihold_publish(false)" :disabled="!blac">
                                    <i class="fa fa-check"></i>
                                    Check It
                                </b-button>

                                <b-button v-if="tabindex == 1" class="ml-2" squared size="sm" variant="primary"
                                    @click="ihold_publish(true)"
                                    :disabled="!blac || published || parseFloat(item.count) == 0">
                                    <i class="fa fa-check"></i>
                                    Publish It
                                </b-button>
                            </b-col>
                            <b-col class="ml-4 mt-1">
                                <b-form-checkbox v-if="tabindex == 1"
                                    :disabled="!blac || published || parseFloat(item.count) == 0"
                                    id="sendannouncementemail" v-model="sendannouncementemail"
                                    name="sendannouncementemail" value="true" unchecked-value="false">
                                    Send announcement email
                                </b-form-checkbox>

                            </b-col>
                            <b-col class="text-left ml-2 mt-1">
                                <div v-if="busy">
                                    <i class="fa fa-spinner fa-spin text-primary"></i>
                                </div>
                                <div v-else>
                                    <span v-html="message"></span>
                                </div>
                            </b-col>

                            <b-col class="text-right" cols="auto">
                                <b-button squared size="sm" variant="secondary" @click="discard">
                                    <i class="fa fa-chevron-left pr-1"></i>
                                    Back
                                </b-button>
                            </b-col>
                        </b-row>

                    </b-card-footer>
                </b-card>
            </div>
        </b-card>
    </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
    name: "InventoryLinesPublish",
    async mounted() {
        await this.accessdenied();
        // this.ticketschange_load();
    },
    props: {
        usesource: { type: String, default: "" },
    },
    data() {
        return {
            busy: false,
            requirement: {
                blac: "Supplier B/L"
            },
            tabindex: 0,
            debounce: 500,
            readonly: false,
            issued_at: {
                startDate: null,
                endDate: null,
            },
            blac: null,
            options_status: [
                { id: "ready", label: "Ready" },
                { id: "pending", label: "Pending" }
            ],
            status_from: 'pending',
            status_to: 'ready',
            blockedevent: true,
            blockedslac: true,
            published: false,
            publishit_message: "",
            publishit_result: false,
            checkit_message: "",
            checkit_result: false,
            sendannouncementemail: "true",
            message: "",
            id: null,
            source: 'chold',
            options_source: [
                // { id: "bhold", label: "Bhold" },
                { id: "chold", label: "Chold" },
                { id: "ghold", label: "Ghold" },
                { id: "xhold", label: "Xhold" },
                // { id: "zhold", label: "Zhold" },
            ],
            blac_options: [
                { id: "BCARDCONF", label: "BCARDCONF" },
                { id: "SVPCONFU", label: "SVPCONFU" },
                { id: "SVPCONF", label: "SVPCONF" }
            ],
            item: {
                from: null,
                to: null,
                cc:null,
                subject: null,
                data: null,
                // created_at: this.$moment().format("YYYY-MM-DD"),
                // updated_at: this.$moment().format("YYYY-MM-DD"),
            },
        };
    },
    watch: {
        usesource: {
            immediate: true,
            async handler(newVal, oldVal) {
                this.source = newVal
            }
        },
        async tabindex() {
            if (this.tabindex == 0) {
                await this.ihold_reset()
            }
        },
        async issued_at() {
            await this.ihold_reset()
        },
        async blac() {
            await this.ihold_reset()
        },
        async blockedevent() {
            await this.ihold_reset()
        },
        async blockedslac() {
            await this.ihold_reset()
        },
        async status_to() {
            if (this.status_to == 'ready') {
                this.status_from = 'pending'
            }
            else {
                this.status_from = 'ready'
            }
            await this.ihold_reset()
        },
        async source() {
            switch (this.source) {
                case "ghold":
                    this.blac = 'BLACKLANE'
                    break;
                case "xhold":
                    this.blac = 'WBAMEX'
                    break;
                default:
                    this.blac = null
            }
        }
    },
    methods: {
        async accessdenied() {

        },
        async ihold_reset() {
            this.publishit_message = ""
            this.checkit_message = ""
            this.checkit_result = false
            this.publishit_result = false
            this.item = {
                from: null,
                to: null,
                cc:null,
                subject: null,
                data: null
            }
        },
        async ihold_publish(apply) {
            this.busy = true;

            let options = ""
            if (!this.blockedevent) {
                options += ",noblockedevent"
            }
            if (!this.blockedslac) {
                options += ",noblockedslac"
            }

            let variables = {
                apply,
                options,
                sendmail: this.sendannouncementemail == 'true' ? true : false,
                blac: this.blac,
                issued_at: [this.issued_at.startDate, this.issued_at.endDate],
                source: this.source,
                status: this.status_to,
                data: this.item.data ? JSON.stringify(this.item.data) : null,
                from: this.item.from,
                to: this.item.to,
                cc: this.item.cc,
                subject: this.item.subject,
            }

            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query ihold_publish(
                                $apply: Boolean
                                $sendmail: Boolean
                                $blac: String
                                $status: String
                                $source: String
                                $options: String
                                $issued_at: [String]
                                $data: String
                                $from: String
                                $cc: String
                                $to: String
                                $subject: String
                            ) {
                                ihold_publish(
                                apply: $apply
                                sendmail: $sendmail
                                blac: $blac
                                status: $status
                                source: $source
                                options: $options
                                issued_at: $issued_at
                                data: $data
                                from: $from
                                cc: $cc
                                to: $to
                                subject: $subject
                                ) {
                                    blockedevents
                                    blockedslacs
                                    count
                                    data
                                    from
                                    cc
                                    to
                                    subject
                                }                         
                        }
                            `,
                    variables,
                });

                if (response.data.ihold_publish) {

                    this.item = response.data.ihold_publish
                    this.item.data = JSON.parse(this.item.data)

                    if (apply) {

                        this.publishit_message = response.data.ihold_publish.count + " row(s) have been updated."
                        this.publishit_result = true

                    } else {

                        this.checkit_message = response.data.ihold_publish.count + " row(s) will be updated. Review details in announcement and Publish It."
                        this.checkit_result = true
                        this.publishit_result = false

                    }
                    // this.message = "<span class='text-primary'>Saved it.</span>";

                }

            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }
            this.published = apply

            this.busy = false;
        },

    },
};
</script>